/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AddonProvisionProjectRequestOneOf } from './AddonProvisionProjectRequestOneOf';
import {
    instanceOfAddonProvisionProjectRequestOneOf,
    AddonProvisionProjectRequestOneOfFromJSON,
    AddonProvisionProjectRequestOneOfFromJSONTyped,
    AddonProvisionProjectRequestOneOfToJSON,
} from './AddonProvisionProjectRequestOneOf';
import type { AddonProvisionProjectRequestOneOf1 } from './AddonProvisionProjectRequestOneOf1';
import {
    instanceOfAddonProvisionProjectRequestOneOf1,
    AddonProvisionProjectRequestOneOf1FromJSON,
    AddonProvisionProjectRequestOneOf1FromJSONTyped,
    AddonProvisionProjectRequestOneOf1ToJSON,
} from './AddonProvisionProjectRequestOneOf1';

/**
 * @type AddonProvisionProjectRequest
 * 
 * @export
 */
export type AddonProvisionProjectRequest = AddonProvisionProjectRequestOneOf | AddonProvisionProjectRequestOneOf1;

export function AddonProvisionProjectRequestFromJSON(json: any): AddonProvisionProjectRequest {
    return AddonProvisionProjectRequestFromJSONTyped(json, false);
}

export function AddonProvisionProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonProvisionProjectRequest {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfAddonProvisionProjectRequestOneOf(json)) {
        return AddonProvisionProjectRequestOneOfFromJSONTyped(json, true);
    }
    if (instanceOfAddonProvisionProjectRequestOneOf1(json)) {
        return AddonProvisionProjectRequestOneOf1FromJSONTyped(json, true);
    }
    return {} as any;
}

export function AddonProvisionProjectRequestToJSON(json: any): any {
    return AddonProvisionProjectRequestToJSONTyped(json, false);
}

export function AddonProvisionProjectRequestToJSONTyped(value?: AddonProvisionProjectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfAddonProvisionProjectRequestOneOf(value)) {
        return AddonProvisionProjectRequestOneOfToJSON(value as AddonProvisionProjectRequestOneOf);
    }
    if (instanceOfAddonProvisionProjectRequestOneOf1(value)) {
        return AddonProvisionProjectRequestOneOf1ToJSON(value as AddonProvisionProjectRequestOneOf1);
    }
    return {};
}

